import style from './TopupCardListingPage.css';
import Title from '../../components/shared/Typography/Title';
import List from '../../components/shared/List/List';
import ListItem from '../../components/shared/List/ListItem';
import CardThumbnail from '../../components/shared/CardThumbnail/CardThumbnail';
import useTranslation from '../../localization/i18n.context';
import NavigationUtils from '../../utils/navigation.utils';
import FormatterUtils from '../../utils/formatter.utils';
import CardStatus from '../../constants/card.status';
import { DeeplinkEvent } from '../../sdk/deeplink.event';
import LuckyDeeplink from '../../constants/lucky.deeplink';
import { CardClients } from '../../clients/clients';
import { _className } from '../../utils/classname.utils';

export default function TopupCardListingView({ cards = [] }) {
  const { t, getOrganization, getCurrency } = useTranslation();

  return (
    <main className={style.main}>
      <Title
        text={t('Select a card to top up')}
        className={style['page-title']}
      />
      <List data-testid='card-list'>
        {cards.map(card => (
          <ListItem
            title={getOrganization(card.organizationCode)}
            subtitle={FormatterUtils.currency(
              card.balance,
              getCurrency(card.currency),
            )
              .split(' ')
              .map(el => {
                return <span> {el}</span>;
              })}
            infoText={
              card.status === CardStatus.LOCKED
                ? t('Locked')
                : ![CardStatus.ACTIVE, CardStatus.SET_PIN].includes(card.status)
                ? t('Inactive')
                : ''
            }
            infoTextClassName={_className(
              card.status === CardStatus.LOCKED,
              style.locked,
            )}
            icon={
              <CardThumbnail
                organization={card.organizationCode}
                size={CardThumbnail.Size.SMALL}
              />
            }
            actionable
            size={ListItem.Size.SMALL}
            onClick={() => {
              if (card.organizationCode === CardClients.LUCKY) {
                DeeplinkEvent.open(LuckyDeeplink.TOPUP);
              } else {
                NavigationUtils.navigate(NavigationUtils.Routes.TOPUP, false, {
                  organization: card.organizationCode,
                });
              }
            }}
            testData={{
              itemTestId: 'card',
              titleTestId: 'card-organization',
              subtitleTestId: 'card-balance',
              infoTestId: 'card-info',
              iconTestId: 'card-icon',
            }}
          />
        ))}
      </List>
    </main>
  );
}
